// @react/hooks/useBillingProduct.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingProductStore } from '@core/stores';

/**
 * React hook for Product operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingProduct } from '@react/hooks';
 *
 * const ProductList = observer(() => {
 *   const store = useBillingProduct();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingProduct() {
  return billingProductStore;
}
